import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Helmet } from 'react-helmet';
import { withNamespaces } from 'react-i18next';
import CreateFamily from 'modules/family/pages/manage/create-family';
import ManageFamily from 'modules/family/pages/manage/manage-family';
import LoadingIntermediate from 'components/indicators/loading-intermdiate';

@withNamespaces()
@inject('store')
@observer
class FamilyManagePage extends Component {
    componentDidMount() {
        const { store } = this.props;
        store.app.setPageTitle('FAMILY.MANAGE.PAGE_TITLE');

        store.family.requestMyFamily();
    }

    render() {
        const { t } = this.props;
        const { family } = this.props.store;
        const { loading } = family;

        return (
            <Fragment>
                <Helmet>
                    <title>{t('FAMILY.MANAGE.PAGE_TITLE')}</title>
                </Helmet>

                <div className="container container-fixed-lg mt-3">
                    <div className="row">
                        {/* Management column */}
                        <div className="col-md-8">
                            {loading ? (
                                <LoadingIntermediate />
                            ) : (
                                family.id ? <ManageFamily /> : <CreateFamily />
                            )}
                        </div>

                        {/* Help column */}
                        <div className="col-md-4">
                            <div className="card bg-info-lighter">
                                <div className="card-header">
                                    <h3 className="card-title">{t('FAMILY.MANAGE.ABOUT.TITLE')}</h3>
                                </div>
                                <div className="card-body">
                                    <p>{t('FAMILY.MANAGE.ABOUT.TEXT')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default FamilyManagePage;


// WEBPACK FOOTER //
// ./src/modules/family/pages/manage/family-manage-page.js